import { Input } from "@material-tailwind/react";
import React from "react";

function FilterInput({ onChange, value }) {
  return (
    <div>
      <Input
        type="text"
        variant="standard"
        label="Filter List"
        value={value}
        onChange={onChange}
      />
    </div>
  );
}

export default FilterInput;
